import { EUserPermissions } from '@zunta/configurations'

const metaWithManager = {
  requiresAuth: true,
  onlyChainUser: true
}

export default [
  {
    name: 'management-mailings',
    path: 'mailings',
    meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_MAILINGS] },
    component: () => import('@/views/app/management/mailings/ManagementMailing.vue')
  },
  {
    name: 'management-mailings-create-new-batch',
    path: 'mailings/create-new-batch',
    meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_MAILINGS] },
    component: () => import('@/views/app/management/mailings/MailingsCreateBatch.vue')
  },
  {
    name: 'management-mailings-batch',
    path: 'mailings/:id',
    meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_MAILINGS] },
    component: () => import('@/views/app/management/mailings/MailingsBatch.vue'),
    children: [
      {
        name: 'management-mailings-statements-batch-unmailed',
        path: 'statements/unmailed',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_MAILINGS] },
        component: () => import('@/views/app/management/mailings/components/StatementsList.vue')
      },
      {
        name: 'management-mailings-statements-batch-mailed',
        path: 'statements/mailed',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_MAILINGS] },
        component: () => import('@/views/app/management/mailings/components/StatementsList.vue')
      },
      {
        name: 'management-mailings-letters-batch-unmailed',
        path: 'letters/unmailed',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_MAILINGS] },
        component: () => import('@/views/app/management/mailings/components/LettersList.vue')
      },
      {
        name: 'management-mailings-letters-batch-mailed',
        path: 'letters/mailed',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_MAILINGS] },
        component: () => import('@/views/app/management/mailings/components/LettersList.vue')
      }
    ]
  }
]
